import React, { useEffect, useMemo, useState } from 'react';
import { Grid, TableBody, Box, CircularProgress } from '@mui/material';
import {
  MdOutlineErrorOutline,
  MdOutlineKeyboardArrowDown,
} from 'react-icons/md';
import { useAccount, useChainId } from 'wagmi';
import Web3 from 'web3';
import { getConnections, waitForTransactionReceipt } from '@wagmi/core';
import { toast } from 'react-toastify';
import cx from 'classnames';

import { BridgeTable } from '../BridgeTable';
import {
  StyledTableCell,
  StyledWithdrawTableRow,
} from '../../../Components/MaterialTableStyle/StyleTableCell';
import ConnectButton from '../../../WagmiProvider/ConnectButton';
import {
  REACT_APP_CHAIN_ID,
  REACT_APP_DAI_TOKEN,
  REACT_APP_ETH_RPC,
  REACT_APP_ETH_TRANSACTION,
  REACT_APP_LIQUIDITY_MANAGER,
  REACT_APP_OPENZK_CHAIN_ID,
  REACT_APP_OZK_TOKEN,
  REACT_APP_OZUSD_TOKEN,
  REACT_APP_USDC_TOKEN,
  REACT_APP_USDT_TOKEN,
} from '../../../Config/Config';
import ozUSDToken from '../../../ContractABI/ozUSD.json';
import liquidityManagerABI from '../../../ContractABI/LiquidityManager.json';
import sUSDS from '../../../ContractABI/sUSDS.json';
import Button from '@mui/material/Button';
import { isDisabled } from '../../../utils/constants';
import ozETHLOGO from '../../../Assets/images/Icons/ozETH.svg';
import ozUSDLOGO from '../../../Assets/images/Icons/ozUSD.svg';
import ETHLOGO from '../../../Assets/images/Icons/Ethreum.svg';
import { useBalance } from '../../../hooks/useBalance';
import CustomModal from '../../../Components/Modal/CustomModal';
import DAILOGO from '../../../Assets/images/Icons/DAILogo.png';
import USDCLOGO from '../../../Assets/images/Icons/USDC.svg';
import USDTLOGO from '../../../Assets/images/Icons/USDT.svg';

import { wagmiAdapterConfig } from '../../../Config/WagmiConfig';
import { CiWallet } from 'react-icons/ci';
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';
import GradiantButton from '../../../Components/Button/GradiantButton';
import { useWithdraw } from '../hooks/useWithdraw';
import { FormatDate } from '../../../Components/DateFormats/DateFromat';
import BigNumber from 'bignumber.js';

const Withdraw = () => {
  const {
    loadWithdrawBalance,
    ozEthL1Balance,
    ozUsdL1Balance,
    resetWithdrawBalance,
  } = useBalance();
  const { withdrawList, fetchWithdrawList } = useWithdraw();
  const chainId = useChainId();
  const connections = getConnections(wagmiAdapterConfig);
  const { isConnected, address } = useAccount();
  const [withdrawStatus, setWithdrawStatus] = useState('Waiting');
  const [isCompleted, setIsCompleted] = useState(false);
  const [txHash, setTxHash] = useState('');
  const [WithdrawTokenModal, setWithdrawTokenModal] = useState(false);
  const [withdrawInProgress, setWithdrawInProgress] = useState(false);
  const [tokenDeliveredModal, setDeliveredTokenModal] = useState(false);
  const [isClaim, setIsClaim] = useState(false);
  const [withdrawValue, setWithdrawValue] = useState('');
  const [convertedWithdrawValue, setConvertedWithdrawValue] = useState('');
  const [transactionIdClaimed, setTransactionIdClaimed] = useState([0]);
  const [selectedDeliveredToken, setSelectedDeliveredToken] = useState({
    Token: 'Ethereum',
    value: 0.0,
    logo: ETHLOGO,
    contract: '',
    symbol: 'ETH',
  });
  const [selectedWithdrawToken, setSelectedWithdrawToken] = useState({
    Token: 'ozETH',
    value: 0.0,
    logo: ozETHLOGO,
    symbol: 'ozETH',
  });
  const WithdrawTokenOption = [
    { Token: 'ozETH', value: 0.0, logo: ozETHLOGO, symbol: 'ozETH' },
    { Token: 'ozUSD', value: 0.0, logo: ozUSDLOGO, symbol: 'ozUSD' },
  ];

  const ozUSDTokensOptions = [
    {
      Token: 'DAI',
      value: 0.0,
      logo: DAILOGO,
      symbol: 'DAI',
      contract: REACT_APP_DAI_TOKEN,
    },
    // {
    //   Token: 'USDC',
    //   value: 0.0,
    //   logo: USDCLOGO,
    //   symbol: 'USDC',
    //   contract: REACT_APP_USDC_TOKEN,
    // },
    // {
    //   Token: 'USDT',
    //   value: 0.0,
    //   logo: USDTLOGO,
    //   symbol: 'USDT',
    //   contract: REACT_APP_USDT_TOKEN,
    // },
  ];

  const ozETHTokensOptions = [
    {
      Token: 'ETH',
      value: 0.0,
      logo: ETHLOGO,
      symbol: 'ETH',
      contract: REACT_APP_OZK_TOKEN,
    },
  ];

  useEffect(() => {
    if (!isConnected || !address) {
      resetWithdrawBalance();
      setWithdrawValue('');
      return;
    }

    if (!isDisabled) {
      loadWithdrawBalance(address);
    }
  }, [address, isConnected, isDisabled]);

  const HandleWithdrawInput = async (value) => {
    // convert withdraw value to DAI
    const walletProvider = await connections[0].connector.getProvider();

    if (!walletProvider) {
      toast.warn('Wallet provider not found');
      return;
    }

    const web3 = new Web3(walletProvider);
    console.log(selectedWithdrawToken?.symbol);
    if (selectedWithdrawToken?.symbol == 'ozUSD') {
      if (Number(value) <= Number(ozUsdL1Balance)) {
        setWithdrawValue(value);

        const ozUSDContract = new web3.eth.Contract(
          ozUSDToken,
          REACT_APP_OZUSD_TOKEN,
        );
        const sUSDSVaultAddress = await ozUSDContract.methods.sUSDSVault().call();
        const sUSDSContract = new web3.eth.Contract(sUSDS, sUSDSVaultAddress);
        const convertedValue = await sUSDSContract.methods.convertToAssets(web3.utils.toWei(value, 'ether')).call();

        setConvertedWithdrawValue(web3.utils.fromWei(convertedValue, "ether"));
      }
    } else {
      if (Number(value) <= Number(ozEthL1Balance)) {
        setWithdrawValue(value);
        const liquidityManagerContract = new web3.eth.Contract(liquidityManagerABI, REACT_APP_LIQUIDITY_MANAGER);
        const ratio = await liquidityManagerContract.methods.previewDeposit(web3.utils.toWei(1, "ether")).call();
        setConvertedWithdrawValue(value / web3.utils.fromWei(ratio, "ether"));
      }
    }
  };

  const handleSelectWithdrawToken = async (item) => {
    if (selectedWithdrawToken?.Token === 'ozUSD') {
      setSelectedDeliveredToken(ozETHTokensOptions[0]);
    } else {
      setSelectedDeliveredToken(ozUSDTokensOptions[0]);
    }
    setSelectedWithdrawToken(item);
    setWithdrawTokenModal(false);
  };

  const handleSelectDeliveredToken = (item) => {
    setSelectedDeliveredToken(item);
    setDeliveredTokenModal(false);
  };

  const handelWithdrawToken = async () => {
    if (chainId !== REACT_APP_CHAIN_ID) {
      toast.warn('Switch Your Network To Ethereum');
      return;
    }

    if (!withdrawValue || withdrawValue?.length === 0) {
      toast.warn('Enter Deposit Amount');
      return;
    }
    if (Number(withdrawValue) <= 0) {
      toast.warn('Deposit Amount must be greater than zero');
    }

    if (!connections || connections.length === 0) {
      toast.warn('No wallet connector found');
      return;
    }

    const walletProvider = await connections[0].connector.getProvider();

    if (!walletProvider) {
      toast.warn('Wallet provider not found');
      return;
    }

    const web3 = new Web3(walletProvider);

    setIsClaim(false);

    if (selectedWithdrawToken.symbol === 'ozETH') {
      await withdrawETHTokens(web3, web3.utils.toWei(withdrawValue, 'ether'));
    }

    if (selectedWithdrawToken.symbol === 'ozUSD') {
      await withdrawUSDTokens(
        web3,
        web3.utils.toWei(withdrawValue, 'ether'),
        selectedDeliveredToken.contract,
      );
    }
    loadWithdrawBalance(address);
    fetchWithdrawList();
  };

  const withdrawUSDTokens = async (web3, amount, token) => {
    setWithdrawInProgress(true);

    try {
      const ozUSDContract = new web3.eth.Contract(
        ozUSDToken,
        REACT_APP_OZUSD_TOKEN,
      );

      const tx =
        token === REACT_APP_DAI_TOKEN
          ? await callWithdrawDai(ozUSDContract, amount)
          : await callWithdrawUsd(ozUSDContract, amount, token);

      try {
        await waitForTransactionReceipt(wagmiAdapterConfig, {
          confirmation: 1,
          hash: tx.transactionHash,
        });
      } catch (error) {
        console.log(error);
        setIsCompleted(false);
        setWithdrawStatus('Error');
      }

      setTxHash(tx.transactionHash);
      setIsCompleted(true);
      setWithdrawStatus('Completed');
    } catch (error) {
      console.log(error);
      setIsCompleted(false);
      setWithdrawStatus('Error');
    }
  };

  const callWithdrawDai = async (contract, amount) => {
    return await contract.methods.queueWithdraw(amount).send({ from: address });
  };

  const callWithdrawUsd = async (contract, amount, token) => {
    return await contract.methods
      .queueWithdrawToken(amount, token)
      .send({ from: address });
  };

  const withdrawETHTokens = async (web3, amount) => {
    setWithdrawInProgress(true);
    try {
      const liquidityManagerContract = new web3.eth.Contract(
        liquidityManagerABI,
        REACT_APP_LIQUIDITY_MANAGER,
      );

      // Estimate gas and add buffer
      const estimatedGas = await liquidityManagerContract.methods
        .queueUnstake(amount)
        .estimateGas({ from: address });
      const tx = await liquidityManagerContract.methods
        .queueUnstake(amount)
        .send({ from: address, gas: estimatedGas * BigInt(110) / BigInt(100) });

      try {
        await waitForTransactionReceipt(wagmiAdapterConfig, {
          confirmation: 1,
          hash: tx.transactionHash,
        });
      } catch (error) {
        console.log(error);
        setIsCompleted(false);
        setWithdrawStatus('Error');
      }

      setTxHash(tx.transactionHash);
      setIsCompleted(true);
      setWithdrawStatus('Completed');
    } catch (error) {
      console.log(error);
      setIsCompleted(false);
      setWithdrawStatus('Error');
    }
  };

  const finalizeWithdraw = async (index, type, id) => {
    if (chainId !== REACT_APP_CHAIN_ID) {
      toast.warn('Switch Your Network To Ethereum');
      return;
    }

    if (!connections || connections.length === 0) {
      toast.warn('No wallet connector found');
      return;
    }

    const walletProvider = await connections[0].connector.getProvider();

    if (!walletProvider) {
      toast.warn('Wallet provider not found');
      return;
    }

    const web3 = new Web3(walletProvider);

    if (type === 'ETH') {
      setWithdrawInProgress(true);
      const liquidityManagerContract = new web3.eth.Contract(
        liquidityManagerABI,
        REACT_APP_LIQUIDITY_MANAGER,
      );

      await callFinalizeWithdraw(liquidityManagerContract, index, type, id);
    }

    if (['USDC', 'USDT', 'DAI'].includes(type)) {
      setWithdrawInProgress(true);
      const ozUSDContract = new web3.eth.Contract(
        ozUSDToken,
        REACT_APP_OZUSD_TOKEN,
      );

      await callFinalizeWithdraw(ozUSDContract, index, type, id);
    }

    fetchWithdrawList();
  };

  const callFinalizeWithdraw = async (contract, index, type, id) => {
    try {
      const tx =
        type === 'ETH'
          ? await contract.methods.unstake(index).send({ from: address })
          : await contract.methods.withdraw(index).send({ from: address });

      try {
        await waitForTransactionReceipt(wagmiAdapterConfig, {
          confirmation: 1,
          hash: tx.transactionHash,
        });
        setIsClaim(true);
        setTransactionIdClaimed((prev) => [...prev, id]);
      } catch (error) {
        console.log(error);
        setIsCompleted(false);
        setWithdrawStatus('Error');
      }

      setTxHash(tx.transactionHash);
      setIsCompleted(true);
      setWithdrawStatus('Completed');
      loadWithdrawBalance(address);
    } catch (error) {
      console.log(error);
      setIsCompleted(false);
      setWithdrawStatus('Error');
    }
  };

  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  });

  const withdrawColumns = [
    {
      id: 1,
      columnName: 'Tk to Withdraw / Unstake',
    },
    {
      id: 2,
      columnName: 'Initiated',
    },
    {
      id: 3,
      columnName: 'Estimated claim date',
    },
  ];

  const DeliveredTokenOptions = useMemo(() => {
    if (selectedWithdrawToken?.Token === 'ozUSD') {
      return ozUSDTokensOptions;
    }
    return ozETHTokensOptions;
  }, [selectedWithdrawToken]);

  return (
    <>
      <Grid
        item
        className="gap-8 w-100"
        lg={12}
        md={12}
        sm={12}
        xs={12}
        display={'flex'}
        flexDirection={'column'}
        alignItems={'flex-start'}
        justifyContent={'flex-start'}
      >
        <Grid
          item
          className="BridgeGlassCard px-3 py-2 w-100"
          height={isConnected ? '100%' : '100%'}
          lg={12}
          md={12}
          sm={12}
          xs={12}
          display={'flex'}
          flexDirection={'column'}
          alignItems={'center'}
          justifyContent={'center'}
        >
          <Grid
            item
            className="w-100 mt-4"
            lg={12}
            md={12}
            sm={12}
            xs={12}
            display={'flex'}
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'space-between'}
          >
            <Grid
              item
              className="BridgeInputBg"
              lg={12}
              md={12}
              sm={12}
              xs={12}
              display={'flex'}
              flexDirection={'row'}
              alignItems={'center'}
              justifyContent={'space-between'}
            >
              <Grid item className="w-100">
                <input
                  type="number"
                  className="p-2"
                  style={{
                    background: 'transparent',
                    color: '#ffffff',
                    width: '100%',
                    border: '0',
                    borderTopLeftRadius: '12px',
                    borderBottomLeftRadius: '12px',
                  }}
                  max={5}
                  placeholder={'Enter Amount'}
                  // disabled={true}
                  value={withdrawValue}
                  onChange={(e) => HandleWithdrawInput(e.target.value)}
                />
              </Grid>

              <Grid
                item
                className="p-2 px-4"
                display={'flex'}
                flexDirection={'row'}
                alignItems={'center'}
                justifyContent={'center'}
                style={{
                  cursor: 'pointer',
                  background: '#28282B',
                  borderTopRightRadius: '12px',
                  borderBottomRightRadius: '12px',
                }}
                onClick={() => setWithdrawTokenModal(true)}
              >
                <p className="BridgeInputText m-0 p-0">
                  {' '}
                  {selectedWithdrawToken?.symbol}{' '}
                </p>{' '}
                <img
                  src={selectedWithdrawToken?.logo}
                  alt="ETH"
                  width={'25px'}
                  height={'25px'}
                  className="mx-1"
                />{' '}
                <MdOutlineKeyboardArrowDown
                  className="mx-1"
                  size={'25px'}
                  style={{ color: '#ffffff' }}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            className="mt-4 w-100"
            lg={12}
            md={12}
            sm={12}
            xs={12}
            display={'flex'}
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'space-between'}
          >
            <h6 className="mt-2 mx-1">Token To Be Delivered</h6>

            {isConnected ? (
              <Grid
                item
                className="py-2"
                display={'flex'}
                flexDirection={'row'}
                alignItems={'center'}
                justifyContent={'center'}
              >
                <Grid
                  item
                  className="py-2 px-2.5"
                  display={'flex'}
                  flexDirection={'row'}
                  alignItems={'center'}
                  justifyContent={'center'}
                  style={{
                    cursor: 'pointer',
                    background: '#28282B',
                    borderRadius: '12px',
                  }}
                  onClick={() => setDeliveredTokenModal(true)}
                >
                  <p className="BridgeInputText m-0 p-0">
                    {' '}
                    {selectedDeliveredToken?.symbol}{' '}
                  </p>{' '}
                  <img
                    src={selectedDeliveredToken?.logo}
                    alt="ETH"
                    width={'25px'}
                    height={'25px'}
                    className="mx-1"
                  />
                  <MdOutlineKeyboardArrowDown
                    className="mx-1"
                    size={'25px'}
                    style={{ color: '#ffffff' }}
                  />
                </Grid>
              </Grid>
            ) : (
              <Grid
                item
                className="BridgeGlassCard px-3 py-2"
                display={'flex'}
                flexDirection={'row'}
                alignItems={'center'}
                justifyContent={'center'}
              >
                <p className="m-0 p-0"> Connect Your Wallet </p>
              </Grid>
            )}
          </Grid>

          <Grid
            item
            className="w-100 mt-4"
            lg={12}
            md={12}
            sm={12}
            xs={12}
            display={'flex'}
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'flex-start'}
          >
            <p className="BridgeInputText m-0 p-0">Balance :</p>
            <p className="ml-2 m-0 p-0" style={{ fontSize: '16px' }}>
              {selectedWithdrawToken?.symbol == 'ozUSD'
                ? formatter.format(ozUsdL1Balance)
                : formatter.format(ozEthL1Balance)}
            </p>
            <div className="mx-1 text-white">
              {selectedWithdrawToken?.symbol}
            </div>
            <Grid
              item
              style={{ cursor: 'pointer' }}
              onClick={() => {
                selectedWithdrawToken?.symbol == 'ozUSD'
                  ? HandleWithdrawInput(ozUsdL1Balance)
                  : HandleWithdrawInput(ozEthL1Balance);
              }}
            >
              <span
                className="mx-2"
                style={{ fontSize: '14px', color: '#FF9854' }}
              >
                Max
              </span>
            </Grid>
          </Grid>

          <Grid
            item
            className="w-100 mt-3 mb-3"
            lg={12}
            md={12}
            sm={12}
            xs={12}
            display={'flex'}
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'space-between'}
          >
            <Grid
              item
              className="BridgeTextBg p-3"
              lg={12}
              md={12}
              sm={12}
              xs={12}
              display={'flex'}
              flexDirection={'column'}
              alignItems={'center'}
              justifyContent={'center'}
            >
              <p className=" m-0 p-0">
                {' '}
                You will receive {convertedWithdrawValue ? convertedWithdrawValue : '0.00'}{' '}
                {selectedDeliveredToken?.symbol}.{' '}
              </p>
              {/* {SelectWithdrawToken?.symbol ? SelectWithdrawToken?.symbol=="ETH"?"ETH": SelectWithdrawToken?.symbol=="DAI"? "DAI" : SelectWithdrawToken?.symbol : "ozETH"}. </p> */}
              <p className="mt-1 m-0 p-0" style={{ color: '#E5772E' }}>
                {' '}
                No Staking Rewards + Airdrop Points.{' '}
              </p>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid
        container
        display={'flex'}
        flexDirection={'column'}
        alignItems={'center'}
        justifyContent={'center'}
        className="BridgeGlassCard px-3 py-2"
      >
        <BridgeTable
          columns={withdrawColumns}
          isEmpty={withdrawList?.length === 0}
          isLoading={false}
        >
          {withdrawList?.length > 0 && (
            <TableBody
              sx={{
                backgroundColor: '#28282B',
                padding: '16px',
                borderRadius: '12px',
              }}
            >
              {withdrawList
                .filter((transaction) => !transaction?.processed)
                .map((withdraw, idx) => (
                  <StyledWithdrawTableRow
                    key={`withdraw-${idx}`}
                    style={
                      idx % 2 == 0
                        ? { background: '#3B3B3D' }
                        : { background: 'transparent' }
                    }
                  >
                    <StyledTableCell
                      sx={{
                        fontFamily: 'Poppins',
                        fontSize: { xs: '12px', md: '16px !important' },
                        fontWeight: '500',
                        lineHeight: '24px',
                      }}
                    >
                      <span>
                        {BigNumber(withdraw?.shares)
                          .div(Math.pow(10, 18))
                          .toString()}{' '}
                      </span>
                      {withdraw.token}
                    </StyledTableCell>
                    <StyledTableCell
                      sx={{
                        fontFamily: 'Poppins',
                        fontSize: { xs: '12px', md: '16px !important' },
                        fontWeight: '500',
                        lineHeight: '24px',
                      }}
                    >
                      <span>
                        {FormatDate(new Date(withdraw?.timestamp).getTime())}
                      </span>
                    </StyledTableCell>
                    <StyledTableCell
                      sx={{
                        fontFamily: 'Poppins',
                        fontSize: { xs: '12px', md: '16px !important' },
                        fontWeight: '500',
                        lineHeight: '24px',
                      }}
                    >
                      {Date.now() >
                      new Date(withdraw?.claimableAt).getTime() ? (
                        <Grid
                          className={cx([
                            'px-4 py-2 rounded-[20px]',
                            transactionIdClaimed.includes(withdraw?.id)
                              ? 'bg-[#94e3f2]'
                              : 'cursor-pointer  bg-[#5773ff]',
                          ])}
                          onClick={() => {
                            !isDisabled &&
                              !transactionIdClaimed.includes(withdraw?.id) &&
                              finalizeWithdraw(
                                withdraw.eventId,
                                withdraw.token,
                                withdraw.id,
                              );
                          }}
                        >
                          <p className="text-center">
                            {transactionIdClaimed.includes(withdraw?.id)
                              ? 'Claiming'
                              : 'Claim'}
                          </p>
                        </Grid>
                      ) : (
                        <span>
                          {FormatDate(
                            new Date(withdraw?.claimableAt).getTime(),
                          )}
                        </span>
                      )}
                    </StyledTableCell>
                  </StyledWithdrawTableRow>
                ))}
            </TableBody>
          )}
        </BridgeTable>
      </Grid>

      <Grid
        item
        className="w-100"
        lg={12}
        md={12}
        sm={12}
        xs={12}
        display={'flex'}
        flexDirection={'row'}
        alignItems={'center'}
        justifyContent={'center'}
      >
        {!isConnected ? (
          <ConnectButton />
        ) : (
          <Button
            className="mr-2"
            sx={{
              height: '40px',
              width: 'auto',
              backgroundColor: '#000000',
              border: 0.75,
              borderColor: '#FC9D4B',
              borderRadius: '10px',
              color: '#FFE584',
              fontWeight: 'semibold',
              fontFamily: 'PoppinsRegular',
              boxShadow: '0px 0px 13px 1px #FC9D4B',
              fontSize: {
                xs: '10px', // For extra small screens (mobile)
                sm: '16px', // For small screens (tablets)
                md: '18px', // For medium screens
                lg: '18px', // For large screens
              },
              padding: {
                xs: '15px', // For extra small screens
                sm: '12px', // For small screens
                md: '15px', // For medium screens
              },
              '&:hover': {
                background:
                  'linear-gradient(90deg, rgba(241, 215, 75, 0.8) 0%, rgba(221, 113, 42, 0.8) 65.9%)',
                color: '#ffffff',
              },
              textTransform: 'none',
            }}
            onClick={() => !isDisabled && handelWithdrawToken()}
          >
            Withdraw
          </Button>
        )}
      </Grid>

      <CustomModal
        open={WithdrawTokenModal}
        setOpen={setWithdrawTokenModal}
        modalTitle={<h4>Select Token</h4>}
        width={{ lg: '30%', md: '30%', xs: '90%', sm: '90%' }}
        modalContent={
          <Grid
            container
            lg={12}
            display={'flex'}
            flexDirection={'column'}
            alignItems={'flex-start'}
            justifyContent={'flex-start'}
            className="m-0 p-0"
          >
            <Grid
              item
              className="px-3 w-100"
              lg={12}
              md={12}
              sm={12}
              xs={12}
              display={'flex'}
              flexDirection={'row'}
              alignItems={'center'}
              justifyContent={'center'}
            >
              <Grid
                item
                className="mb-3"
                lg={11}
                md={11}
                sm={11}
                xs={11}
                display={'flex'}
                flexDirection={'column'}
                alignItems={'center'}
              >
                {WithdrawTokenOption && WithdrawTokenOption?.length > 0
                  ? WithdrawTokenOption?.map((item, i) => {
                      return (
                        <Grid
                          item
                          key={i}
                          className="w-100 p-3 mt-2"
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          display={'flex'}
                          flexDirection={'row'}
                          alignItems={'flex-start'}
                          justifyContent={'space-between'}
                          style={{
                            background: '#FFFFFF0F',
                            borderRadius: '15px',
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            handleSelectWithdrawToken(item);
                          }}
                        >
                          <Grid
                            item
                            display={'flex'}
                            flexDirection={'row'}
                            alignItems={'center'}
                          >
                            <img
                              src={item?.logo}
                              alt="tokenlogo"
                              width={'30px'}
                              height={'30px'}
                              className="mx-2"
                            />
                            <p className="airdrop_text">{item?.Token}</p>
                          </Grid>
                          <p className="airdrop_text">
                            {item?.symbol == 'ozETH'
                              ? formatter.format(ozEthL1Balance)
                              : formatter.format(ozUsdL1Balance)}
                          </p>
                        </Grid>
                      );
                    })
                  : ''}
              </Grid>
            </Grid>
          </Grid>
        }
      />

      <CustomModal
        open={withdrawInProgress}
        setOpen={setWithdrawInProgress}
        closebtn={'remove'}
        modalTitle={<h5>Wallet Actions</h5>}
        width={{ lg: '30%', md: '30%', xs: '90%', sm: '90%' }}
        modalContent={
          <Grid
            container
            lg={12}
            display={'flex'}
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'center'}
          >
            <Grid
              container
              lg={12}
              display={'flex'}
              flexDirection={'row'}
              alignItems={'center'}
              justifyContent={'space-between'}
              className="p-2 rounded"
              bgcolor={'rgba(0, 0, 0, 0.32)'}
            >
              <Grid className="d-flex">
                <p>
                  {' '}
                  <CiWallet className="text-light mx-2" size={30} /> Withdraw is
                  loading
                </p>
              </Grid>

              {withdrawStatus === 'Waiting' ? (
                <span style={{ color: '#ffffff' }}>Waiting</span>
              ) : withdrawStatus === 'Loading' ? (
                <span>
                  <CircularProgress
                    fourColor
                    style={{ color: '#FFF' }}
                    size={20}
                  />
                </span>
              ) : withdrawStatus === 'Completed' ? (
                <p>
                  {' '}
                  <IoMdCheckmarkCircleOutline
                    style={{ color: '#FC9D4B' }}
                    size={20}
                  />
                </p>
              ) : (
                <p>
                  <MdOutlineErrorOutline
                    style={{ color: '#FC9D4B' }}
                    size={20}
                  />
                </p>
              )}
            </Grid>

            <Grid
              container
              lg={12}
              display={'flex'}
              flexDirection={'row'}
              alignItems={'center'}
              justifyContent={'center'}
              className="mt-4 w-100 "
            >
              {isCompleted ? (
                <p
                  className="airdrop_paratext mb-3 p-3"
                  style={{
                    border: '1px solid #ffffff',
                    borderRadius: '25px',
                    textAlign: 'center',
                  }}
                >
                  {`${withdrawStatus === 'Error' ? 'Error encountered during contract execution' : isClaim ? 'Your withdraw was finalized' : `${withdrawValue} ${selectedWithdrawToken?.symbol} withdraw initiated`}`}{' '}
                </p>
              ) : (
                withdrawStatus === 'Error' && (
                  <p
                    className="airdrop_paratext mb-3 p-3"
                    style={{
                      border: '1px solid #ffffff',
                      borderRadius: '25px',
                      textAlign: 'center',
                    }}
                  >
                    Error: withdraw transaction has errors
                  </p>
                )
              )}{' '}
              {txHash !== '' ? (
                <>
                  <a
                    href={REACT_APP_ETH_TRANSACTION + txHash}
                    target="blank"
                    style={{
                      color: '#fff',
                      width: '70%',
                      marginBottom: '20px',
                    }}
                  >
                    <GradiantButton
                      btnTextColor="#FFF"
                      text={'CHECK ETHERSCAN'}
                      borderColor={'#FC9D4B'}
                      width="100%"
                    />
                  </a>

                  <GradiantButton
                    btnTextColor="#FFF"
                    text={'CLOSE'}
                    borderColor={'#FC9D4B'}
                    width="70%"
                    onClick={() => {
                      {
                        setWithdrawInProgress(false);
                        setWithdrawValue('');
                        setTxHash('');
                        setIsCompleted(false);
                        setWithdrawStatus('Waiting');
                      }
                    }}
                  />
                </>
              ) : (
                <GradiantButton
                  btnTextColor="#FFF"
                  text={!isCompleted ? 'CLOSE' : 'CHECK ETHERSCAN'}
                  borderColor={'#FC9D4B'}
                  width="100%"
                  onClick={() => {
                    setWithdrawInProgress(false);
                    setTxHash('');
                    setIsCompleted(false);
                    setWithdrawStatus('Waiting');
                  }}
                />
              )}
            </Grid>
          </Grid>
        }
      />

      {tokenDeliveredModal && (
        <CustomModal
          open={tokenDeliveredModal}
          setOpen={setDeliveredTokenModal}
          modalTitle={<h4>Select Token</h4>}
          width={{ lg: '30%', md: '30%', xs: '90%', sm: '90%' }}
          modalContent={
            <Grid
              container
              lg={12}
              display={'flex'}
              flexDirection={'column'}
              alignItems={'flex-start'}
              justifyContent={'flex-start'}
              className="m-0 p-0"
            >
              <Grid
                item
                className="px-3 w-100"
                lg={12}
                md={12}
                sm={12}
                xs={12}
                display={'flex'}
                flexDirection={'row'}
                alignItems={'center'}
                justifyContent={'center'}
              >
                <Grid
                  item
                  className="mb-3"
                  lg={11}
                  md={11}
                  sm={11}
                  xs={11}
                  display={'flex'}
                  flexDirection={'column'}
                  alignItems={'center'}
                >
                  {DeliveredTokenOptions && DeliveredTokenOptions?.length > 0
                    ? DeliveredTokenOptions?.map((item, i) => {
                        return (
                          <Grid
                            item
                            key={i}
                            className="w-100 p-3 mt-2"
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            display={'flex'}
                            flexDirection={'row'}
                            alignItems={'flex-start'}
                            justifyContent={'space-between'}
                            style={{
                              background: '#FFFFFF0F',
                              borderRadius: '15px',
                              cursor: 'pointer',
                            }}
                            onClick={() => {
                              handleSelectDeliveredToken(item);
                            }}
                          >
                            <Grid
                              item
                              display={'flex'}
                              flexDirection={'row'}
                              alignItems={'center'}
                            >
                              <img
                                src={item?.logo}
                                alt="tokenlogo"
                                width={'30px'}
                                height={'30px'}
                                className="mx-2"
                              />
                              <p className="airdrop_text">{item?.Token}</p>
                            </Grid>
                          </Grid>
                        );
                      })
                    : ''}
                </Grid>
              </Grid>
            </Grid>
          }
        />
      )}
    </>
  );
};

export default Withdraw;
